import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import Pagination from 'components/Pagination';
import Search from 'components/Search';
import WhatToSeeList from 'components/WhatToSeeList';

import { makeAfter, withData } from 'lib';
import { ContentWhatToSeeListPageQuery } from '__generated__/ContentWhatToSeeListPageQuery.graphql';

const query = graphql`
  query ContentWhatToSeeListPageQuery($first: Int!) {
    ...WhatToSeeList_data @arguments(first: $first)
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ContentWhatToSeeListPageQuery>;
};

const ContentWhatToSeeListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<ContentWhatToSeeListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/content', name: 'Turinys' },
        { name: 'Ką pamatyti' },
      ]}>
      <Search>
        <Pagination>
          <WhatToSeeList data={data} />
        </Pagination>
      </Search>
    </Page>
  );
};

export default withData<ContentWhatToSeeListPageQuery>({
  query,
  variables: ({ currentUser, searchParams }) => ({
    first: currentUser.itemsPerPage,
    after: makeAfter(
      Number(searchParams.get('page')) || 0,
      currentUser.itemsPerPage
    ),
  }),
})(ContentWhatToSeeListPage);
